module.exports = __webpack_public_path__ + "img/BreakThroughLogo.81d4f2a4.svg";